import * as React from 'react';
import { Eye, EyeOff } from 'react-feather';
import styled from 'styled-components';
import { borderRadius, boxShadow, color, flex, height, space, width, background } from 'styled-system';
import { StyledSystemProps } from '../../theme/StyledSystemProps';
import { ThemeInterface } from '../../theme/ThemeInterface';

type Props = StyledSystemProps & {
  bg?: string;
  name?: string;
  type?: string;
  color?: string;
  width?: string;
  height?: string;
  paddingLeft?: string;
  boxShadow?: string;
  placeholder?: string;
  showEyeIcon?: boolean;
  passwordVisible?: boolean;
  children?: React.ReactNode;
  onTogglePassword?: () => void;
  disabled?: boolean;
  borderRadius?: string | number;
  id?: string;
  onChange?: (e: any) => void;
  autoComplete?: string;
  value?: string;
  min?: number;
  max?: number;
};

export const StyledInput = styled.input`
  ${flex};
  ${space};
  ${width};
  ${color};
  ${height};
  ${boxShadow};
  ${borderRadius};
  ${background};
  padding-left: 10px;
  display: flex;
  position: relative;
  border-style: none;
  box-sizing: border-box;
  outline-color: rgba(50, 115, 220);
  box-shadow: inset 0 0 0 1px rgba(67, 90, 111, 0.15), inset 0 1px 2px rgba(67, 90, 111, 0.15);
  font-size: ${(props: ThemeInterface) => props.theme.fontSizes[0]};
  &:disabled {
    opacity: 0.5;
  }
`;

const InputWrap = styled.div`
  display: flex;
  position: relative;
  align-items: center;
  width: 100%;
`;

const StyledEye = styled(Eye)<any>`
  right: 10px;
  width: 20px;
  height: 20px;
  color: #404041;
  position: absolute;
  &:hover {
    cursor: pointer;
  }
`;

const StyledEyeOff = styled(EyeOff)<any>`
  right: 10px;
  width: 20px;
  height: 20px;
  color: #404041;
  position: absolute;
  &:hover {
    cursor: pointer;
  }
`;

const PasswordIcon = (props: Props) => {
  return props.passwordVisible ? (
    <StyledEyeOff onClick={props.onTogglePassword} />
  ) : (
    <StyledEye onClick={props.onTogglePassword} />
  );
};

const Input: React.FC<Props> = (props: Props) => {
  return (
    <InputWrap>
      <StyledInput autoComplete={props.autoComplete} as="input" {...props} />
      {props.showEyeIcon && PasswordIcon(props)}
    </InputWrap>
  );
};

export default Input;

Input.defaultProps = {
  width: '100%',
  height: '40px',
  bg: 'paleGrey',
  borderRadius: 4,
  passwordVisible: false,
  showEyeIcon: false,
};



// WEBPACK FOOTER //
// ./src/components/formElements/StyledInput.tsx